/*=========================================================================================
  Nom du fichier: moduleSuspectMutations.js
  Description: Suspect Module Mutations
  ----------------------------------------------------------------------------------------
  Author: Djezou Eric Martial
==========================================================================================*/

export default {
  SET_SUSPECT (state, data) {
    state.suspects = data
  },
  ADD_SUSPECT (state, data) {
    state.suspects.unshift(data)
  },
  UPDATE_SUSPECT (state, data) {
    const index = state.suspects.length > 0 ? state.suspects.findIndex((s) => s._id === data._id) : null

    if (index === 0 || index !== null) {
      Object.assign(state.suspects[index], data)
    }
  },
  DELETE_SUSPECT (state, id) {
    const index = state.suspects.length > 0 ? state.suspects.findIndex((s) => s._id === id) : null
    state.suspects.splice(index, 1)
  }
}